import { Registry } from 'react-form-builder2';

export const registerComponent = (name: string, component: any) => {
    if (!Registry.get(name)) {
        Registry.register(name, component);
    }
};